import { LinkProps } from '../../atoms/link/Link'

export type BackgroundColour = 'Orange' | 'Purple' | 'Teal' | 'White' | 'LightPurple'
export type LinkStyle = 'Primary' | 'Secondary' | 'Alternate'

export const backgroundColorClassMap: Record<Lowercase<BackgroundColour>, string> = {
  orange: 'bg-orange-10',
  purple: 'bg-purple-100',
  lightpurple: 'bg-purple-10',
  teal: 'bg-teal-10',
  white: 'bg-white',
}

export const textColorClassMap: Record<Lowercase<BackgroundColour>, string> = {
  orange: 'text-black',
  purple: 'text-white',
  lightpurple: 'text-black',
  teal: 'text-black',
  white: 'text-black',
}

export const primaryLinkVariants: Record<Lowercase<BackgroundColour>, LinkProps['intent']> = {
  orange: 'orange',
  purple: 'primaryLight',
  lightpurple: 'primaryDark',
  teal: 'teal',
  white: 'primaryDark',
}

export const secondaryLinkVariants: Record<Lowercase<BackgroundColour>, LinkProps['intent']> = {
  orange: 'outlineDark',
  purple: 'outlineLight',
  lightpurple: 'outlineDark',
  teal: 'outlineDark',
  white: 'outlineDark',
}
